// src/components/layouts/MainLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Sidebar from './Sidebar';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout = () => {
  const { currentUser } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar on location change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location]);

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar if clicking outside on mobile
  const handleMainContentClick = () => {
    if (sidebarOpen && window.innerWidth <= 991) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="main-layout">
      {currentUser && <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />}
      
      <div 
        className={`main-content ${currentUser ? '' : 'no-sidebar'} ${sidebarOpen ? 'sidebar-active' : ''}`}
        onClick={handleMainContentClick}
      >
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="page-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;